import React from 'react';
import { motion } from 'framer-motion';
import { fadeIn } from '../../../lib/motion';
import { useSignedUrl } from '../../../services/uploads';
import { isPending } from '../../courses/editors/contentPlaceholder';
import ModuleViewContainer from './ModuleViewContainer';

export interface PdfViewProps {
  item: { file_url?: string; filename?: string; size_bytes?: number; title?: string };
  mode: 'learner' | 'preview';
}

const PdfView: React.FC<PdfViewProps> = ({ item, mode }) => {
  const key = item.file_url && !isPending(item.file_url) && !item.file_url.startsWith('http')
    ? item.file_url
    : null;
  const { data: signedData } = useSignedUrl(key);
  const viewerUrl = key ? signedData?.url : item.file_url ?? null;

  const body = viewerUrl ? (
    <iframe
      src={`${viewerUrl}#navpanes=0`}
      title={item.filename ?? 'PDF document'}
      className="w-full flex-1 min-h-[600px] rounded-lg border border-border bg-surface-primary"
    />
  ) : null;

  if (mode === 'learner') {
    return (
      <motion.div {...fadeIn} className="w-full flex-1 flex flex-col min-h-0">
        <ModuleViewContainer padding="px-4 pb-4">
          {item.title && (
            <div className="px-5 sm:px-6 pt-5 sm:pt-6 pb-3">
              <h2 className="text-lg sm:text-xl font-bold text-text-primary leading-tight">
                {item.title}
              </h2>
            </div>
          )}
          <div className="flex-1 flex flex-col min-h-0 px-3 sm:px-4 pb-3 sm:pb-4">
            {body}
          </div>
        </ModuleViewContainer>
      </motion.div>
    );
  }

  return (
    <motion.div {...fadeIn} className="w-full">
      {body}
    </motion.div>
  );
};

export default PdfView;
